export const getPathString = path => path.join('.collections.');

